import { cloneDeep } from 'lodash'
import { areGivenStringsEqual } from '@feedyou/utils'
import botSchema from '@feedyou-ai/feedbot-schema/schema/botFlow.json'
import { NlpProviderMetadata, NlpSettings } from '@feedyou-ai/feedbot-schema'

import { isModelTypeDescriptionBased } from '../../../../features/nlpModel'

export function getSchema(
  areNlpProvidersEnabled: boolean,
  isNlpKbChatProviderEnabled: boolean,
  areIntentsWithDescriptionEnabled: boolean
) {
  const schema = cloneDeep(botSchema.properties.nlp)
  omitSchemaProperties(schema)
  schema.properties.models.title = 'Models'

  if (!areIntentsWithDescriptionEnabled) {
    schema.properties.models.items.properties.entities.items.anyOf =
      schema.properties.models.items.properties.entities.items.anyOf.filter(
        entity => !entity.properties.type.default.startsWith('llm-')
      )
  }

  return removeNlpProvidersFromSchema(
    schema,
    areNlpProvidersEnabled,
    isNlpKbChatProviderEnabled,
    areIntentsWithDescriptionEnabled
  )
}

function removeNlpProvidersFromSchema(
  schema: Partial<NlpSettings>,
  areNlpProvidersEnabled: boolean,
  isNlpKbChatProviderEnabled: boolean,
  areIntentsWithDescriptionEnabled: boolean
): Partial<NlpSettings> {
  const schemaCopy = cloneDeep(schema)
  const providers: NlpProviderMetadata[] =
    schemaCopy?.properties?.models?.items?.properties?.provider?.anyOf || []

  if (!providers.length) {
    return schemaCopy
  }

  if (!areNlpProvidersEnabled) {
    schemaCopy.properties.models.items.properties.provider.anyOf = providers.filter(
      (provider: NlpProviderMetadata) =>
        areGivenStringsEqual('feedyou', provider?.properties.type.const) ||
        areGivenStringsEqual('llm-classifier', provider?.properties.type.const) ||
        areGivenStringsEqual('openai-chat', provider?.properties.type.const)
    )
    return schemaCopy
  }

  if (!areIntentsWithDescriptionEnabled) {
    schemaCopy.properties.models.items.properties.provider.anyOf = providers.filter(
      provider => !isModelTypeDescriptionBased(provider?.properties.type.const)
    )
  }

  if (!isNlpKbChatProviderEnabled) {
    schemaCopy.properties.models.items.properties.provider.anyOf = providers.filter(
      provider => provider?.properties.type.const !== 'kb-chat'
    )
  }

  return schemaCopy
}

function omitSchemaProperties(schema?: any): void {
  delete schema.title
  delete schema.properties.faq
  delete schema.properties.triggers
  delete schema.properties?.stepNlp
  delete schema.properties.allowedDialogs
  delete schema.properties.excludedDialogs
  delete schema.properties.excludedStepIds
  delete schema.properties?.models?.items?.properties?.intents
}
